var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.searchIsActive || _vm.mobileSearchIsActive)?_c('ul',{staticClass:"search-suggestions"},_vm._l((_vm.suggestions),function(suggestion){return _c('li',{staticClass:"search-suggestions__suggestion"},[_c('search-link',{attrs:{"item":suggestion.item}})],1)}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }